// @flow

import React from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import ActiveFiltersButtonComponent from './activeFiltersButton';
import { getSelectedFiltersCount } from '../../../store/assortment';
import { getFilterButtonText, getActionableButtonText } from '../../../store/assortmentSettings';

type OwnProps = {|
  onClick: Function,
  icon: Node,
|};

type StateProps = {|
  count: number,
  filterButtonText: string,
  actionableButtonText: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const ActiveFiltersButton = ({
  count,
  onClick,
  filterButtonText,
  actionableButtonText,
  icon,
}: Props) => (
  <ActiveFiltersButtonComponent
    count={count}
    onClick={onClick}
    filterButtonText={filterButtonText}
    actionableButtonText={actionableButtonText}
    icon={icon}
  />
);

const mapStateToProps = (state): StateProps => ({
  count: getSelectedFiltersCount(state),
  filterButtonText: getFilterButtonText(state),
  actionableButtonText: getActionableButtonText(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(ActiveFiltersButton);
